import axiosInstance from './axiosInstance';

const BASE = '/coding-tracker';

// ─── Batches ──────────────────────────────────────────────────────────────────
export const getBatches      = ()      => axiosInstance.get(`${BASE}/batches`);
export const getBatchById    = (id)    => axiosInstance.get(`${BASE}/batches/${id}`);
export const createBatch     = (data)  => axiosInstance.post(`${BASE}/batches`, data);
export const deleteBatch     = (id)    => axiosInstance.delete(`${BASE}/batches/${id}`);

// ─── Progress ─────────────────────────────────────────────────────────────────
export const getBatchProgress  = (batchId)      => axiosInstance.get(`${BASE}/batches/${batchId}/progress`);
export const getBatchDashboard = (batchId)       => axiosInstance.get(`/dashboard/batch/${batchId}`);

// Legacy aliases (used by existing pages)
export const fetchBatches        = getBatches;
export const fetchBatchProgress  = getBatchProgress;
export const fetchBatchDashboard = getBatchDashboard;
